import * as Amenities from './Amenities.css';

export default {
	Amenities
};
